import Vue from 'vue'
import VueRouter from 'vue-router'
import Frame from '../components/Frame.vue'
import Illustrate from '../views/illustrate.vue'
import Initialize from '../views/initialize.vue'
import SetBasicInfo from '../views/setBasicInfo.vue'
import SetTopSpec from '../views/setTopSpec.vue'
import SetImages from '../views/setImages.vue'
import UserInfo from '../views/userInfo.vue'
import Orders from '../views/orders.vue'
import Login from '../views/Login.vue'
import Official from '../views/official.vue'
import Pay from '../views/pay.vue'
import Register from '../views/register.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Official',
		component: Official,
		meta:{
			title:'证件照研究院——考试证件照网页/模块'
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta:{
			title:'证件照研究院——考试证件照网页/模块商户后台登录'
		}
	},
	{
		path: '/illustrate',
		name: 'Illustrate',
		component: Illustrate,
		meta:{
			title:'产品指引'
		}
	},
	{
		path: '/initialize',
		name: 'Initialize',
		component: Initialize,
		meta:{
			title:'产品初始化'
		}
	},
	{
		path: '/pay',
		name: 'Pay',
		component: Pay,
		meta:{
			title:'充值'
		}
	},
	{
		path: '/register',
		name: 'Register',
		component: Register,
		meta:{
			title:'商户注册'
		}
	},
	{
		path: '/setBasicInfo',
		component: Frame,
		children: [{
			path: '',
			name: 'setBasicInfo',
			component: SetBasicInfo,
			meta:{
				title:'基本信息设置'
			}
		}]
	},
	{
		path: '/setTopSpec',
		component: Frame,
		children: [{
			path: '',
			name: 'setTopSpec',
			component: SetTopSpec,
			meta:{
				title:'首页规格设置'
			}
		}]
	},
	{
		path: '/setImages',
		component: Frame,
		children: [{
			path: '',
			name: 'setImages',
			component: SetImages,
			meta:{
				title:'轮播图设置'
			}
		}]
	},
	{
		path: '/userInfo',
		component: Frame,
		children: [{
			path: '',
			name: 'userInfo',
			component: UserInfo,
			meta:{
				title:'用户信息'
			}
		}]
	},
	{
		path: '/orders',
		component: Frame,
		children: [{
			path: '',
			name: 'orders',
			component: Orders,
			meta:{
				title:'订单信息'
			}
		}]
	},
]

const router = new VueRouter({
  mode: 'hash',
  base: "/edu/admin",
  routes
})

export default router
